export const formatTerminalsByNumber = (terminals: any[] = []) => {
  return terminals.reduce((acc, terminal) => {
    const {
      terminalNumber,
      airportCode,
      terminalName,
    } = terminal;

    if (terminalNumber) {
      acc[terminalNumber] = `${airportCode} - ${terminalName} - ${terminalNumber}`;
    }

    return acc;
  }, {} as Record<string, string>);
};
export const removeEmptyValues = <T extends Record<string, any>>(obj: T): Partial<T> =>
  Object.fromEntries(
    Object.entries(obj).filter(
      ([_, value]) =>
        value !== "" &&
        value !== undefined &&
        value !== null
    )
  ) as Partial<T>;

export const getDisabledDayValues = (weekStartDate: string) => {
  const start = new Date(weekStartDate);
  const today = new Date();

  // Normalize time
  start.setHours(0, 0, 0, 0);
  today.setHours(0, 0, 0, 0);

  const diffInDays =
    Math.floor((today.getTime() - start.getTime()) / (1000 * 60 * 60 * 24));

  return diffInDays >= 0 ? diffInDays + 1 : 0;
};
